import React from "react";
import { Row, Col } from "antd";
import { showConfirmDlgWidget } from "components/ConfirmDlgWidget/showConfirmDlgWidget";
import { DeleteOutlined, EditFilled } from "@ant-design/icons";

export function showColumnAction(info, setVisible, setUserData, deleteData) {
  return (
    <Row gutter={16}>
      <Col>
        <a
          style={{ color: "var(--blueColor)" }}
          onClick={async () => {
            setUserData(info);
            setVisible(info);
          }}
        >
          <EditFilled /> Edit
        </a>
      </Col>
      <Col>
        <a
          style={{ color: "red" }}
          onClick={async () => {
            var res = await showConfirmDlgWidget({
              title: "Delete Confirmation",
              content: "Are you sure you want to delete this audience?",
            });
            if (res == false) return;
            deleteData(info.id);
          }}
        >
          <DeleteOutlined /> Delete
        </a>
      </Col>
    </Row>
  );
}
